import type { CSSProperties, ReactNode } from 'react';

import classnames from 'classnames';

import styles from './Banner.module.css';

export type BannerVariant =
  | 'default'
  | 'kale-2'
  | 'oyster-0'
  | 'white'
  | 'chickpea-0'
  | 'chickpea-2';

export interface BannerProps {
  variant?: BannerVariant;
  style?: CSSProperties;
  className?: string;
  children?: ReactNode;
}

/**
 * Render a banner to display a succinct message with a call to action.
 *
 * @cssVariable --tfd-banner-min-height The minimum height of the banner to support a single line of text
 * @see https://corgi-x.tfd.engineering/components/banner
 */
export function Banner(props: BannerProps) {
  const { className, variant = 'default' } = props;
  return (
    <div
      className={classnames(styles.root, className, styles[variant])}
      style={props.style}
      role="banner"
    >
      {props.children}
    </div>
  );
}
